import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import React from 'react';
// eslint-disable-next-line max-len
import type { Props as TypographyProps } from '@fortress-technology-solutions/fortress-component-library/Atoms/Typography/Typography.types';

type Props = {
  title: React.ReactNode,
  content: React.ReactNode,
  titleTypographyProps?: TypographyProps,
  contentTypographyProps?: TypographyProps,
};

export default function InfoContainer({
  title,
  content,
  titleTypographyProps,
  contentTypographyProps,
}: Props) {
  return (
    <Box display="flex" flexDirection="column">
      <Typography
        variant="titleSmall"
        {...titleTypographyProps}
        sx={{ mb: 1, ...titleTypographyProps?.sx }}
      >
        {title}
      </Typography>
      <Typography
        variant="bodyMedium"
        color="text.secondary"
        {...contentTypographyProps}
      >
        {content}
      </Typography>
    </Box>
  );
}
